import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { Category } from '../models';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {
  private readonly endpoint = '/categories';

  constructor(private apiService: ApiService) {}

  /**
   * Ottiene tutte le categorie
   */
  getAll(): Observable<{ success: boolean; data: Category[] }> {
    return this.apiService.get<{ success: boolean; data: any[] }>(
      `${this.endpoint}?onlyPublished=true`
    ).pipe(
      map(response => ({
        success: response.success,
        data: response.data.map(cat => this.mapCategory(cat))
      }))
    );
  }

  /**
   * Ottiene una categoria per slug
   */
  getBySlug(slug: string): Observable<{ success: boolean; data: Category }> {
    return this.apiService.get<{ success: boolean; data: any }>(
      `${this.endpoint}/${slug}`
    ).pipe(
      map(response => ({
        success: response.success,
        data: this.mapCategory(response.data)
      }))
    );
  }

  /**
   * Mappa i dati della categoria dal backend al frontend
   * Converte i campi snake_case in camelCase
   */
  private mapCategory(cat: any): Category {
    return {
      id: cat.id,
      name: cat.name,
      slug: cat.slug,
      description: cat.description,
      color: cat.color,
      icon: cat.icon,
      episodeCount: cat.episode_count,
      createdAt: cat.created_at,
      updatedAt: cat.updated_at
    };
  }
}
